import imageCompression from "browser-image-compression";

export const compressImage = async (dataUrl: string, maxSizeMB: number): Promise<string> => {
    const file = await imageCompression.getFilefromDataUrl(dataUrl, "image.jpg");
    const compressed = await imageCompression(file, { maxSizeMB, useWebWorker: true });
    return imageCompression.getDataUrlFromFile(compressed);
};
